import { Route, Routes } from 'react-router-dom'
import { ProfissionalDeSaudeListWrapper } from './profissional-saude/ProfissionalDeSaudeList'
import { FC } from 'react'
import { PageTitle } from '_metronic/layout/core'
import { useT } from '_metronic/i18n/Metronici18n'

const ProfissionaisPage: FC = () => {
  const { t } = useT()

  return (
    <Routes>
      <Route
        path=''
        element={
          <>
            <PageTitle description={t('pagina.profissionais.descricao')}>
              Profissionais de Saúde
            </PageTitle>
            <ProfissionalDeSaudeListWrapper />
          </>
        }
      />
    </Routes>
  )
}

export default ProfissionaisPage
